export default __webpack_public_path__ + "static/media/CourtyardMap.574e687d.jpg";